var map = {
	"./Central-mobile.jpg": 1141,
	"./Mandurah-mobile.jpg": 1142,
	"./North-mobile.jpg": 1143,
	"./South-mobile.jpg": 1144,
	"./default-mobile.jpg": 1145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1140;